import React, { Component } from 'react'
import injectSagas from 'helpers/injectSagas'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Flex, Box } from 'reflexbox'
import Input from './Input'

import CardTitle from './CardTitle'
import Card from './Card'
import AddButton from './AddButton'
import AddPopup from 'containers/ProductSearchPage/AddPopup/index'
import Grid from 'components/fulcrum/grid/index'
import Layout from './Layout'
import {
  fetchEmployeeListWithImages as fetchEmployeeList,
} from 'containers/User/actions'
import {
  employeeListWithImageValues as employeeListSelector,
  isLoadingEmployeeList,
} from 'containers/User/selectors'
import {
  initializeProductList,
  updateInputValue,
  onEnterPress,
  onTogglePopup,
  fetchSkus,
  postForm,
} from './actions'
import {
  listSelector,
  inputValueSelector,
  activeAddDialogSelector,
  creatingProductSelector,
  productSkuSourcesSelector,
  segmentSourcesSelector,
  lineSourcesSelector,
  loadingSkuListSelector
} from './selectors'
import ProductSagas from './sagas'


const mapStateToProps = (state) => {
  return {
    // for product list
    list: listSelector(state),
    inputValue: inputValueSelector(state),
    // for add dialog
    activeAddDialog: activeAddDialogSelector(state),
    creatingProduct: creatingProductSelector(state),
    segmentSources: segmentSourcesSelector(state),
    lineSources: lineSourcesSelector(state),
    productSkuSources: productSkuSourcesSelector(state),
    loadingSkuList: loadingSkuListSelector(state),
    employeeList: employeeListSelector(state),
    isEmployeeListLoading: isLoadingEmployeeList(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // for product list
    initialize: () => dispatch(initializeProductList()),
    updateInputValue: (value) => dispatch(updateInputValue(value)),
    onEnterPress: (event) => dispatch(onEnterPress(event)),
    // for add dialog
    fetchEmployeeList: (query) => dispatch(fetchEmployeeList(query)),
    onTogglePopup: (value) => dispatch(onTogglePopup(value)),
    onSegmentLineChange: (segment, line) => dispatch(fetchSkus(segment, line)),
    onSave: (productDetails) => dispatch(postForm(productDetails))
  }
}

class ProductSearchPage extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.initialize()
  }

  getProductLink = (productId) => {
    return `/product/${productId}/view`
  }

  render() {
    const {
      list,
      inputValue,
      updateInputValue,
      onEnterPress,
      onTogglePopup,
      onSave,
      activeAddDialog,
      creatingProduct,
      segmentSources, 
      lineSources,
      onSegmentLineChange,
      productSkuSources,
      loadingSkuList,
      fetchEmployeeList, 
      employeeList,
      isEmployeeListLoading,
    } = this.props
    return (
      <Layout>
        <Card>
          <Flex pr={2} justify='space-between'>
            <CardTitle>
              Product List
            </CardTitle>
            <Flex pr={2} justify='flex-end'>
              <Input
                icon='search'
                hint= 'Search Product...'
                value={inputValue}
                onChange={updateInputValue}
                onKeyPress={onEnterPress}
              />
              <AddButton 
                onClick={onTogglePopup}
                />
              <AddPopup 
                onTogglePopup={onTogglePopup}
                popupActive={activeAddDialog}
                creatingProduct={creatingProduct}
                onSave={onSave}
                segmentSources={segmentSources}
                lineSources={lineSources}
                onSegmentLineChange={onSegmentLineChange}
                productSkuSources={productSkuSources}
                loadingSkuList={loadingSkuList}
                fetchEmployeeList={fetchEmployeeList}
                employeeList={employeeList}
                isEmployeeListLoading={isEmployeeListLoading}
              />
            </Flex>
          </Flex>
          <Box auto>
            <Grid
              list={list} 
              loadOnScroll={false} 
              showContextMenu={false} 
              setColumnReorder={false}
              cellClick={true}
              getCellClickURL={this.getProductLink}
            />
          </Box>
        </Card>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ ProductSagas })
const enhance = compose(
  withConnect,
  withSagas
)

export default enhance(ProductSearchPage)